import type { TextChain } from '@/api/types/stowed-element'
import { isLinkedTextFrame } from '@/lib/groups/linked-text-group-policy'
import type { PhotoDropCandidateFrame } from '@/lib/photos/types/photo-drop-candidate-frame'

/**
 * True when this drop target belongs to a text-link chain, and so must never receive a ClikArt —
 * the ClikArt-side counterpart of `lib/photos/linked-text-photo-drop-policy.ts`'s
 * `isPhotoDropBlockedByTextChain`, which carries the full rationale (filling a chain member is
 * destructive, not merely untidy — see that file). Delegates to the same `isLinkedTextFrame`
 * rather than a third copy of the predicate (WMPCM-8969).
 */
export function isClikArtDropBlockedByTextChain(
  frame: PhotoDropCandidateFrame,
  chains: readonly TextChain[]
): boolean {
  return isLinkedTextFrame(frame, chains)
}

/** Shown when a ClikArt is dropped on a linked text frame — mirrors
 *  `LINKED_TEXT_PHOTO_DROP_BLOCKED_MESSAGE`'s wording (names the object and the one action that
 *  unblocks it). */
export const LINKED_TEXT_CLIKART_DROP_BLOCKED_MESSAGE =
  'Cannot place a ClikArt in a linked text frame. Unlink it first.'
